import { useState } from 'react';
import { Label } from '../pilot-ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../pilot-ui/select';

interface FieldSelectProps {
  id: string;
  label: string;
  help: string;
  value: string;
  options: { value: string; label: string; title?: string }[];
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  error?: string;
  ariaLabel?: string;
  onOpenChange?: (open: boolean) => void;
}

export default function FieldSelect({
  id, label, help, value, options, onChange, disabled, className, error, ariaLabel, onOpenChange,
}: FieldSelectProps) {
  const [open, setOpen] = useState(false);
  const items = Object.fromEntries(options.map(option => [option.value, option.label]));
  const updateOpen = (next: boolean) => {
    setOpen(next);
    onOpenChange?.(next);
  };

  return (
    <div className={className}>
      <Label htmlFor={id}>{label}</Label>
      <Select items={items} value={value} onValueChange={next => onChange(next ?? '')}
        open={open} onOpenChange={updateOpen} disabled={disabled}>
        <SelectTrigger id={id} aria-describedby={`${id}-help${error ? ` ${id}-error` : ''}`}
          aria-label={ariaLabel} aria-invalid={!!error} title={help} className="w-full">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map(option => (
            <SelectItem key={option.value} value={option.value} title={option.title}>{option.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p id={`${id}-help`} className="text-xs text-muted-foreground">{help}</p>
      {error && <p id={`${id}-error`} className="text-xs text-destructive" role="alert">{error}</p>}
    </div>
  );
}
